import React from 'react';
import { Box, Modal } from '@mui/material';
import PropTypes from 'prop-types';

export default function ViewProfilePhoto({
  visible,
  onClose,
  photoUrl,
}) {
  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: 2,
          '&:focus-visible': {
            outline: 'none',
          }
        }}
      >
        <Box
          onClick={onClose}
          component="img"
          src={photoUrl}
          alt="view_profile_photo"
          sx={{ borderRadius: '8px' }}
        />
      </Box>
    </Modal>
  );
}

ViewProfilePhoto.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
